import LogoIconCollection from './LogoIconCollection';
import mapProps from 'recompose/mapProps';

const enhance = mapProps(props => ({
  ...props.primary,
  items: props.items,
}));

export default enhance(LogoIconCollection);



// WEBPACK FOOTER //
// ./src/client/js/view/components/LogoIconCollection/index.js